import React, { PureComponent } from 'react';
import ConfigurationFields from '../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_TEMPLATIZED_API } from '../../../constants/connectionCategories';
import UIUtils from '../../../lib/UIUtils';

class TemplatizedAPISinkConfiguration extends PureComponent {
  render() {
    const { data } = this.props;
    return (
      <ConfigurationFields
        {...this.props}
        connectionCategory={CONNECTION_CATEGORY_TEMPLATIZED_API}
        config={UIUtils.buildTemplatizedAPIConfigFromSource(data)}
      />
    );
  }
}

export default TemplatizedAPISinkConfiguration;
